function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,94.517 13.807,53.453 22.125,48.146 35.568,23.012 36.816,9.916 39.288,4.954 46.37,4.605  53.444,11.151 53.444,22.126 57.344,30.976 61.949,30.976 67.792,37.17 72.036,37.7 96.985,9.376 100.353,9.916 102.475,4.605  107.082,3.182 108.312,6.373 116.812,6.725 119.298,15.223 123.367,15.577 127.252,20.883 125.483,27.968 141.412,34.161  138.58,39.472 146.896,42.122 177.518,64.96 190.439,79.114 200,83.011 192.915,103.362 131.333,109.029 109.199,149.562  108.85,161.589 113.803,162.48 113.803,170.796 109.554,174.685 111.328,190.624 107.601,196.818 3.363,113.448 "
});

var Svg07 = function Svg07(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CHIS",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg07, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/07.651994a2.svg";
export { ForwardRef as ReactComponent };